<button [ngClass]="{ disabled: disabled(), displayBlock: block() }" [class]="color()">
  @if (loading()) {
    <p-progressSpinner styleClass="w-2rem h-2rem" ariaLabel="loading" class="customProgressSpinner" />
  } @else {
    @if (buttonText()) {
      <span>{{ buttonText() ?? "" | translate }}</span>
    }
    @if (buttonIcon()) {
      <span>
        <app-svg-icon [iconName]="buttonIcon()" iconColor="primary" iconSize="xs"></app-svg-icon>
      </span>
    }
  }
</button>
